import { render } from "./InputComponent.vue?vue&type=template&id=38ea613a&scoped=true&ts=true"
import script from "./InputComponent.vue?vue&type=script&lang=ts"
export * from "./InputComponent.vue?vue&type=script&lang=ts"

import "./InputComponent.vue?vue&type=style&index=0&id=38ea613a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ea613a"]])

export default __exports__